import {BASE_FORM_MESSAGES, FORM_ERROR} from '@constants/messages';
import {SPIIDEO_COMPETITOR_MAPPING} from '@constants/resources';
import {
    GetSpiideoCompetitorMappingForForm,
} from '@graphql/spiideoCompetitorMapping/query';
import {
    CreateSpiideoCompetitorMapping,
    DeleteSpiideoCompetitorMapping,
    UpdateSpiideoCompetitorMapping,
} from '@graphql/spiideoCompetitorMapping/mutation';
import {GetSportsForDropdown} from '@graphql/sport/query';

import Form from '../../app/components/ReduxFormControls';
import validate from './validatorSpiideoCompetitorMapping';

export default function SpiideoCompetitorMappingModel() {
    return {
        entityDataMapKey: 'spiideoCompetitorMapping',
        entityLabel: 'Spiideo competitor mapping',
        formName: 'spiideoCompetitorMapping',
        label: 'Spiideo competitor mapping',
        resources: SPIIDEO_COMPETITOR_MAPPING,
        showChangeLog: true,
        validate,
        title: null,
        dataMap: {
            spiideoCompetitorMapping: {
                id: '',
                competitor: {id: '', name: ''},
                spiideo_team_uuid: '',
                sportradar_srt_url: '',
                ligr_srt_url: '',
            },
        },
        messages: {
            boxName: {
                error: 'spiideoCompetitorMappingError',
                success: 'spiideoCompetitorMapping',
            },
            text: {
                ...BASE_FORM_MESSAGES,
                FORM_ERROR: () => FORM_ERROR('Spiideo competitor mapping'),
            },
        },
        fields: {
            id: {
                component: Form.IdField,
                dataMapKey: 'spiideoCompetitorMapping.id',
                props: {
                    hidden: true,
                    label: '',
                    name: 'id',
                },
            },
            sport: {
                optionsKey: 'sports',
                props: {
                    component: Form.SemanticSelect,
                    label: 'Sport',
                    name: 'sport',
                    placeholder: 'Select sport',
                    required: true,
                },
            },
            tournament_category: {
                props: {
                    component: Form.SemanticSelect,
                    label: 'Category',
                    name: 'tournament_category',
                    placeholder: 'Select category',
                    required: true,
                    hidden: true,
                },
            },
            competitor: {
                props: {
                    component: Form.SemanticSelect,
                    label: 'Competitor',
                    name: 'competitor',
                    placeholder: 'Start typing at least 3 characters...',
                    required: true,
                    hidden: true,
                    search: true,
                    searchQuery: '',
                },
            },
            spiideo_team_uuid: {
                dataMapKey: 'spiideoCompetitorMapping.spiideo_team_uuid',
                props: {
                    component: Form.SemanticInput,
                    label: 'Spiideo team UUID',
                    name: 'spiideo_team_uuid',
                    required: true,
                    type: 'input',
                },
            },
            sportradar_srt_url: {
                dataMapKey: 'spiideoCompetitorMapping.sportradar_srt_url',
                props: {
                    component: Form.SemanticInput,
                    label: 'Sportradar SRT URL',
                    name: 'sportradar_srt_url',
                    required: true,
                    type: 'input',
                },
            },
            ligr_srt_url: {
                dataMapKey: 'spiideoCompetitorMapping.ligr_srt_url',
                props: {
                    component: Form.SemanticInput,
                    label: 'LIGR SRT URL',
                    name: 'ligr_srt_url',
                    required: true,
                    type: 'input',
                },
            },
        },
        mutation: {
            createEntity: CreateSpiideoCompetitorMapping,
            updateEntity: UpdateSpiideoCompetitorMapping,
            deleteEntity: DeleteSpiideoCompetitorMapping,
        },
        query: {
            getEntity: GetSpiideoCompetitorMappingForForm,
            getOptions: GetSportsForDropdown,
        },
    };
}
